// extracted by mini-css-extract-plugin
export default {"agreementList":"Agreements_agreementList__3PJqX","agreement":"Agreements_agreement__WGpUl"};